var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecoIco4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04834 3.92886L34.7676 31.6481L32.1525 34.2631L4.43332 6.54388L7.04834 3.92886Z",
    fill: "#D7922A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7675 6.54386L7.04824 34.2631L4.43322 31.6481L32.1524 3.92884L34.7675 6.54386Z",
    fill: "#D7922A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6218 1.59538L14.0088 37.9708L10.5771 36.5922L25.1901 0.216797L28.6218 1.59538Z",
    fill: "#D7922A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3508 13.1044L2.29658 28.4928L0.844843 25.0915L36.8991 9.7031L38.3508 13.1044Z",
    fill: "#D7922A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0981 28.1163L0.722656 13.5033L2.10124 10.0716L38.4767 24.6846L37.0981 28.1163Z",
    fill: "#D7922A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5913 37.8508L10.2029 1.7966L13.6042 0.344865L28.9926 36.3991L25.5913 37.8508Z",
    fill: "#D7922A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoIco4);
export default __webpack_public_path__ + "static/media/decoIco4.51ce1492feec5a1ed2c61d84b55225fb.svg";
export { ForwardRef as ReactComponent };